<template>
  <div class="container-fluid full-width-page-wrapper">
    <h3 class="font-weight-bold page-title mb-3">
      {{ heading }}
    </h3>

    <b-overlay :show="loading">
      <b-card v-if="organization">
        <dl class="row mb-0">
          <dt class="col-sm-4">Country/Region</dt>
          <dd class="col-sm-8">{{ organization.country?.name || '-' }}</dd>

          <dt class="col-sm-4">{{ organizationLabel }}</dt>
          <dd class="col-sm-8">{{ organization.name || '-' }}</dd>

          <dt class="col-sm-4">Head</dt>
          <dd class="col-sm-8">
            <router-link
              v-if="organization.headAffiliate?.id"
              :to="`/affiliates/${organization.headAffiliate.id}`"
            >
              {{ formatAffiliate(organization.headAffiliate) }}
            </router-link>
            <span v-else>{{ formatAffiliate(organization.headAffiliate) }}</span>
          </dd>

          <dt class="col-sm-4">Correspondent</dt>
          <dd class="col-sm-8">
            <router-link
              v-if="organization.correspondantAffiliate?.id"
              :to="`/affiliates/${organization.correspondantAffiliate.id}`"
            >
              {{ formatAffiliate(organization.correspondantAffiliate) }}
            </router-link>
            <span v-else>{{ formatAffiliate(organization.correspondantAffiliate) }}</span>
          </dd>

          <dt class="col-sm-4">Contact email</dt>
          <dd class="col-sm-8">{{ organization.contactInfo?.email || '-' }}</dd>

          <dt class="col-sm-4">Postal address</dt>
          <dd class="col-sm-8">{{ organization.contactInfo?.postal_address || '-' }}</dd>

          <dt class="col-sm-4">Web link</dt>
          <dd class="col-sm-8">
            <a
              v-if="organization.contactInfo?.web_link"
              :href="organization.contactInfo.web_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ organization.contactInfo.web_link }}
            </a>
            <span v-else>-</span>
          </dd>
        </dl>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MemberOrganizationView',
  props: {
    organizationType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      organization: null,
    };
  },
  computed: {
    ...mapState({
      nmos: (state) => state.nationalMemberOrganizations.data,
      amos: (state) => state.associateMemberOrganizations.data,
    }),
    organizations() {
      return this.organizationType === 'amo' ? this.amos : this.nmos;
    },
    heading() {
      return this.organizationType === 'amo'
        ? 'Associate Member Organization'
        : 'National Member Organization';
    },
    organizationLabel() {
      return this.organizationType === 'amo' ? 'AMO name' : 'NMO name';
    },
  },
  async created() {
    await this.fetchOrganization();
  },
  methods: {
    async fetchOrganization() {
      this.loading = true;
      try {
        const { countryCode } = this.$route.params;
        let organization = this.findOrganization(countryCode);

        if (!organization) {
          const action = this.organizationType === 'amo'
            ? 'associateMemberOrganizations/fetchAMOs'
            : 'nationalMemberOrganizations/fetchNMOs';
          const organizations = await this.$store.dispatch(action);
          organization = this.findOrganization(countryCode, organizations);
        }

        if (organization) {
          this.organization = organization;
        } else {
          this.$snack.danger({ text: 'Could not load this organization.' });
          this.goBack();
        }
      } catch (error) {
        console.error(error);
        this.$snack.danger({ text: 'Could not load this organization.' });
        this.goBack();
      } finally {
        this.loading = false;
      }
    },
    findOrganization(countryCode, organizations = this.organizations) {
      const normalizedCountryCode = countryCode?.toUpperCase();

      return organizations.find(
        (o) => o.country?.code?.toUpperCase() === normalizedCountryCode,
      ) ?? null;
    },
    formatAffiliate(affiliate) {
      if (!affiliate) {
        return '-';
      }

      const name = [affiliate.title, affiliate.name, affiliate.surname]
        .filter(Boolean)
        .join(' ')
        .trim();

      if (!name) {
        return '-';
      }

      return name;
    },
    goBack() {
      this.$router.push({
        path: '/affiliates/officials',
        query: { category: this.organizationType },
      });
    },
  },
};
</script>
